const updates = [
  { date: '2026-07-31', title: '热门都市剧《星辰大海》全集上线', tag: '新剧上线' },
  { date: '2026-07-30', title: '榴莲视频独家综艺《欢乐集结号》更新至第12期', tag: '综艺更新' },
  { date: '2026-07-29', title: '红杏视频热播古装《长安夜未央》大结局已出', tag: '剧集完结' },
  { date: '2026-07-28', title: '国际院线大片《极速追击》高清版正式登陆', tag: '电影上线' },
  { date: '2026-07-27', title: '播放线路全面升级，新增3条高速CDN通道', tag: '系统优化' },
  { date: '2026-07-26', title: '动漫专区新增《星辰变》《完美世界》等热门国漫', tag: '片库扩充' },
  { date: '2026-07-25', title: '4K超清专区上线，百余部大片支持超高清画质', tag: '功能上线' },
  { date: '2026-07-24', title: '悬疑剧《迷雾追踪》第二季火热开播，全网首更', tag: '新季开播' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            实时动态
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            最新更新动态
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            向日葵视频每日同步更新，最新剧集、电影、综艺动态一网打尽
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updates.map((item, idx) => (
              <div key={idx} className="relative mb-8 last:mb-0">
                <div className="absolute -left-[41px] w-4 h-4 rounded-full bg-primary-500 border-4 border-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap font-mono">
                    {item.date}
                  </span>
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-2 text-sm md:text-base text-foreground-700 font-medium">
                  {item.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}